import React, { useState } from 'react';
import { Typography, Tooltip } from '@mui/material';

export const CellText = ({ text, type = 'text', maxLength = 40, isPinned = false }) => {
  const [expanded, setExpanded] = useState(false);
  
  if (text == null || text === '') return <Typography variant="body2" sx={{ opacity: 0.3 }}>-</Typography>;
  
  const str = String(text);
  const currentMax = expanded ? 9999 : (isPinned ? 100 : maxLength);
  const isTruncated = str.length > currentMax;

  // ... (rest of number and boolean logic)
  if (type === 'number') {
    return (
      <Typography 
        variant="body2" 
        sx={{ 
          textAlign: 'right', 
          fontWeight: 600, 
          fontFamily: '"JetBrains Mono", "Roboto Mono", "Consolas", monospace',
          color: '#0f172a',
          fontSize: '0.72rem',
          letterSpacing: '-0.02em',
        }}
      >
        {str}
      </Typography>
    );
  }

  if (type === 'boolean') {
    return <Typography variant="body2" sx={{ textAlign: 'center', color: '#64748b', fontWeight: 500, fontSize: '0.7rem' }}>{str}</Typography>;
  }

  // Premium Text styling
  const typoProps = {
    variant: "body2",
    sx: { 
      fontFamily: '"Inter", "Plus Jakarta Sans", -apple-system, Roboto, sans-serif',
      color: '#334155',
      fontWeight: 500,
      fontSize: '0.72rem',
      letterSpacing: '-0.01em',
      lineHeight: 1.35,
      // Line Clamping logic
      display: (isPinned && !expanded) ? '-webkit-box' : 'block',
      WebkitLineClamp: (isPinned && !expanded) ? 2 : 'none',
      WebkitBoxOrient: 'vertical',
      whiteSpace: (isPinned && !expanded) ? 'normal' : (expanded ? 'normal' : 'nowrap'),
      wordBreak: 'break-word',
      overflow: 'hidden',
      textOverflow: (isPinned || expanded) ? 'clip' : 'ellipsis',
      transition: 'all 0.2s ease-in-out'
    }
  };

  if (!isTruncated && !expanded && !isPinned) {
    return <Typography {...typoProps}>{str}</Typography>;
  }

  return (
    <Tooltip title={expanded ? '' : (str.length > currentMax ? str : '')} arrow disableInteractive enterDelay={500}>
      <Typography 
        {...typoProps}
        sx={{ 
          ...typoProps.sx, 
          cursor: 'pointer', 
          '&:hover': { color: 'primary.main', textDecoration: isPinned ? 'none' : 'underline' } 
        }}
        onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}
      >
        {expanded ? str : (str.length > currentMax ? `${str.substring(0, currentMax)}...` : str)}
      </Typography>
    </Tooltip>
  );
};
